import { useWLHomeCurrency } from '@src/providers/WLCustomerUserConfigContextProvider';
import { useWLOrgConfigContext } from '@src/providers/WLOrgConfigProvider';
import { useEffect, useMemo } from 'react';
import { useBalancesContext, useCurrenciesContext } from '../../../../contexts';
import { useObservableValue } from '../../../../hooks';
import { useWLTradingLimits } from '../../../WLTradingLimitsProvider';
import { useWLOrderFormDispatch, useWLOrderFormSelector } from '../../WLOrderFormStore';
import { setSwapDependencies, setSwapReferenceData } from './reducer';
import { selectSwapTradingLimitsArguments } from './selector';

/**
 * This hook is responsible for calling the useWLTradingLimits hook and propagating the results to the OrderSlice state
 */
export function useSwapDependencies() {
  const dispatch = useWLOrderFormDispatch();

  const { listBalances } = useBalancesContext();
  const balances = useObservableValue(() => listBalances, [listBalances]);

  useEffect(() => {
    dispatch(setSwapDependencies({ balances }));
  }, [balances, dispatch]);

  const { currenciesBySymbol } = useCurrenciesContext();
  const { config } = useWLOrgConfigContext();
  const { homeCurrencyObject } = useWLHomeCurrency();
  const favoredPairCurrency = useMemo(() => {
    if (config.favoredPairCurrency) {
      return currenciesBySymbol.get(config.favoredPairCurrency);
    }
  }, [currenciesBySymbol, config.favoredPairCurrency]);

  useEffect(() => {
    dispatch(setSwapReferenceData({ homeCurrency: homeCurrencyObject }));
  }, [homeCurrencyObject, dispatch]);

  useEffect(() => {
    if (favoredPairCurrency) {
      dispatch(setSwapReferenceData({ favoredPairCurrency }));
    }
  }, [favoredPairCurrency, dispatch]);

  const tradingLimitsProps = useWLOrderFormSelector(selectSwapTradingLimitsArguments);
  const tradingLimitsValidationResult = useWLTradingLimits(tradingLimitsProps);

  useEffect(() => {
    dispatch(setSwapDependencies({ tradingLimitsValidation: tradingLimitsValidationResult }));
  }, [tradingLimitsValidationResult, dispatch]);
}
